module.exports = __webpack_public_path__ + "img/rail2.3611b953.png";